import { themeColors } from "../../themeColors";
import { useCurrentWebsite } from "../../hooks/useCurrentWebsite";
import React, { useState, useEffect } from "react";
import PageTransition from "../../components/Common/PageTransition";
import { Button } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import IntroSentIcon from "../../images/intro-sent-icon.svg";
import IntroTagIcon from "../../images/intro-tag-icon.svg";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import MoreIcon from "../../images/more-icon.svg";
import InventorySuccessModal from "../../components/Inventory/CreateInventory/InventorySuccessModal";
import {
  getInventoryById,
  inventoryMarkAsSold,
  deleteMyInventory,
} from "../../services/inventoryService";
import StrengthenIcon from "../../images/ad-strengthen-icon.svg";
import AdIntroIcon from "../../images/ad-intro-icon.svg";
import MarkAsSoldConfirmModal from "../../components/Inventory/MarkAsSoldConfirmModal";
import HelpFeedbackModal from "../../components/Inventory/HelpFeedbackModal";
import DeleteModal from "../../components/Common/DeleteModal";
import {
  PropertyWantAdListing,
  SelectDropDown,
  MatchesSkeleton,
} from "@/components";
import { DefaultProfile } from "@/images";
import { formatInventoryAddress } from "@/helpers";
import { useMatches } from "@/hooks";
import {
  INVENTORY_ALL_TYPE,
  INVENTORY_KEY,
  INVENTORY_LAND,
  INVENTORY_LTR,
  INVENTORY_LTR_STR,
  INVENTORY_SELL,
  INVENTORY_SELL_LTR,
  INVENTORY_SELL_STR,
  INVENTORY_STR,
  IS_LAND,
  PAGE_LIMIT,
  NICE_2_HAVES_CATEGORIES_MASTER_LIST,
  NICE_2_HAVES_LOT_LAND_CATEGORIES,
  USER_TYPE_MEMBER,
} from "../../constants/common";
import { pageURLs } from "../../constants/pageURLs";
import {
  buildInventoryMustHaveHtml,
  checkInventoryType,
} from "../../helpers/inventory";
import { useNavigate, useSearchParams, NavLink, useLocation } from "react-router-dom";
import {
  getLocalStorage,
  getUserId,
  loggedInUser,
  removeDecimalZeros,
  setLocalStorage,
  thousandSeperatedValue,
  truncate,
  replaceComma,
  getUserType,
} from "../../helpers/common";
import { convertToNumber } from "../../helpers/validations";
import {
  getMyAcceptedIntroductionByInvId,
  getMyPendingIntroductionByInvId,
} from "../../services/introductionService";
import {
  favouriteWantAd,
  unFavouriteWantAd,
} from "../../services/wantAdService";
import moment from "moment";
import { toast } from "react-toastify";
import _ from "lodash";
import { wantAdSqftValue } from "../../helpers/createWantAd";
import { useRef } from "react";
import { useSelector } from "react-redux";
import MapBoxComponent from "../../components/Common/MapboxComponent";
import { downloadIconTwo } from "@/images";
import { PageWrapper } from "@/components/PageWrapper";
import SchoolSmallIcon from "../../images/school-icon.svg";
import NeighborhoodIcon from "../../images/neighborhood-icon.svg";
import PlaceHolderIcon from "../../images/dpdown-placeholder-icon.svg";
import PhotoGallery from "@/components/Common/PhotoGallery";

const InventoryDetails = (props) => {

  const navigate = useNavigate();
  const { isGitchaDefaultWebsite } = useCurrentWebsite();
  const options = [
    { value: "most_relevant", label: "Most relevant" },
    { value: "most_recent", label: "Most recent" },
  ];


  const routerDomLocation = useLocation();
  const isFromConfirmationPage = routerDomLocation.state?.isFromConfirmationPage;

  const [searchParams] = useSearchParams();
  const [showSuccessModal, setSuccessModal] = useState(false);
  const [showStrengthen, setShowStrengthen] = useState(false);
  const [inventoryDetails, setInventoryDetails] = useState();
  const [pendingIntroductions, setPendingIntroductions] = useState([]);
  const [pendingIntroductionsCount, setPendingIntroductionsCount] = useState(
    [],
  );
  const [acceptedIntroductionsCount, setAcceptedIntroductionsCount] = useState(
    [],
  );
  const [markAsSoldModalShow, setMarkAsSoldModal] = useState(false);
  const handleMarkAsSoldModal = (status) => setMarkAsSoldModal(status);
  const [markAsSoldStatus, setMarkAsSoldStatus] = useState(false);
  const [showGitchaHelpFeedbackModal, setShowGitchaHelpFeedbackModal] =
    useState(false);
  const GitchaHelpFeedbackModalShow = () =>
    setShowGitchaHelpFeedbackModal(true);
  const GitchaHelpFeedbackModalClose = () =>
    setShowGitchaHelpFeedbackModal(false);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [deleteStatus, setDeleteStatus] = useState(false);

  const inventory = getLocalStorage(INVENTORY_KEY);

  const tabInitial = searchParams.get("tabKey");
  const [tabKey, setTabKey] = useState(tabInitial || "Property Details");
  const [matchQuery, setMatchQuery] = useState({
    inventoryId: inventory?.inventoryId,
    limit: 20,
    page: 1,
    sortType: options[0].value,
  });

  const { matches, totalMatches, hasNextPage, isMatchesLoading, fetchMatches } =
    useMatches();

  const propertyType = convertToNumber(
    _.get(inventoryDetails, "prprtyType", ""),
  );
  const proprtyPurpose = _.get(inventoryDetails, "proprtyPurpose", []);
  const invType = checkInventoryType(proprtyPurpose);
  const nice2Have = _.get(inventoryDetails, "nice2Have", []);
  const typeBasedOnProperty =
    propertyType === IS_LAND ? INVENTORY_LAND : invType;

  const isSold = _.get(inventoryDetails, "isSold", "");
  const mapImg = _.get(inventoryDetails, "mapImg", "");
  const lat = _.get(inventoryDetails, "lat", "");
  const lng = _.get(inventoryDetails, "lng", "");

  const timeLineTxt =
    _.get(inventoryDetails, "timeLineTxt", "") ||
    _.get(inventoryDetails, "tlText", "");
  const description = _.get(inventoryDetails, "invtryDetails", "");
  const salesPercnt = removeDecimalZeros(
    _.get(inventoryDetails, "salesPercnt", ""),
  );
  const salesPercntLTR = removeDecimalZeros(
    _.get(inventoryDetails, "salesPercnt_LTR", ""),
  );
  const salesPercntSTR = removeDecimalZeros(
    _.get(inventoryDetails, "salesPercnt_STR", ""),
  );
  const showStrengthenSuccess = _.get(
    inventory,
    "showStrengthenSuccessModal",
    false,
  );
  const agent = _.get(inventoryDetails, "isAgentCreated", "");

  let isEdit = _.get(inventory, "isEdit", ""); // to display success toast

  //This variable is used for hiding strengthen want ad section and change intro title and description, if this page reaches from inventory listing.
  const isFromListingPage = _.get(inventory, "isFromListingPage", null);

  const inventoryId = _.get(inventory, "inventoryId", "");

  const userDetails = loggedInUser();
  const pageTopRef = useRef(null);

  const isMember = userDetails?.userInfo?.userType === USER_TYPE_MEMBER;

  useEffect(() => {
    if (tabKey === "Matches") {
      fetchMatches(matchQuery);
    }
  }, [tabKey, matchQuery]);

  const handleSuccessModalClose = (isClosePopUp) => {
    setSuccessModal(false);
    updateLocalStorage(); // This is for removing the 'showSuccessModal' key from the state to avoid showing the popup again in page refresh.
  };

  const updateLocalStorage = () => {
    const inventoryId = _.get(inventory, "inventoryId", "");
    setLocalStorage(INVENTORY_KEY, { inventoryId: inventoryId });
  };

  useEffect(() => {
    window.scrollTo(0, pageTopRef.current.offsetTop); // focus to the top section
    fetchMatches(matchQuery);
    const inventoryId = _.get(inventory, "inventoryId", null);
    const showSuccess = _.get(inventory, "showSuccessModal", null);
    if ((showSuccess || showStrengthenSuccess) && isEdit == false) {
      setSuccessModal(true);
    } else if (!isFromListingPage && isEdit) {
      setSuccessModal(false);
      toast.success("Your inventory has been edited.");
      let newSession = { ...inventory, isEdit: false };
      setLocalStorage(INVENTORY_KEY, newSession);
    }
    getInventoryDetails(inventoryId);
    getPendingIntroductionList();
    getAcceptdIntroductions();
  }, []);

  useEffect(() => {
    if (
      (invType === INVENTORY_SELL ||
        invType === INVENTORY_ALL_TYPE ||
        invType === INVENTORY_SELL_LTR ||
        invType === INVENTORY_SELL_STR ||
        invType === INVENTORY_LTR ||
        invType === INVENTORY_LTR_STR) &&
      !_.get(inventoryDetails, "isStrengthen", false) &&
      !isFromListingPage &&
      propertyType !== IS_LAND
    ) {
      setShowStrengthen(true);
    } else {
      setShowStrengthen(false);
    }
  }, [inventoryDetails]);
  /**
   * To get inventory details
   * @param {*} inventoryId
   */
  const getInventoryDetails = async (inventoryId) => {
    if (inventoryId) {
      await getInventoryById(inventoryId)
        .then((response) => {
          const responseResult = _.get(response, "result", null);
          if (response.errorCode === 0 && responseResult) {
            setInventoryDetails(responseResult);
          } else {
            console.log("Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    } else {
      userDetails?.userType == 1
        ? navigate(pageURLs.memberCreateInventory)
        : navigate(pageURLs.agentCreateInventory);
    }
  };

  let titleText = "";
  if (isSold) {
    titleText = "Closed ";
  } else {
    switch (invType) {
      case INVENTORY_SELL:
        titleText = " selling";
        break;
      case INVENTORY_LTR:
        titleText = " renting";
        break;
      case INVENTORY_STR:
        titleText = " renting";
        break;
      case INVENTORY_LTR_STR:
        titleText = " renting";
        break;
      case INVENTORY_SELL_LTR:
        titleText = " selling, renting";
        break;
      case INVENTORY_SELL_STR:
        titleText = " selling, renting";
        break;
      case INVENTORY_ALL_TYPE:
        titleText = " selling, renting";
        break;
    }
  }

  const handleStrengthenDismiss = () => {
    setShowStrengthen(false);
  };
  /**
   * To load nice to haves section
   * @param {*} section
   * @returns
   */
  const loadEachNiceToHave = (section) => {
    const selectedItems =
      nice2Have && nice2Have.filter((item) => item.tab === section);
    return loadNiceToHaveList(selectedItems, section.charAt(0));
  };

  const finalNiceToHaveList = () => {
    const niceToHaveMasterArray = typeBasedOnProperty === INVENTORY_LAND ?
      NICE_2_HAVES_LOT_LAND_CATEGORIES.map((item) => item.category) :
      NICE_2_HAVES_CATEGORIES_MASTER_LIST.map((item) => item.category);

    const finalList =
      niceToHaveMasterArray &&
      niceToHaveMasterArray.map((nh) => {
        return loadEachNiceToHave(nh);
      });
    return finalList;
  };

  const loadNiceToHaveList = (list, uniqueType) => {
    return (
      list &&
      list.map((tl) => {
        const id = _.get(tl, "id");
        const itemText = _.get(tl, "text", "");
        const icon = _.get(tl, "icon", "");
        return (
          <div className="nicetohaves-tag" key={id + uniqueType}>
            <div className="nicetohaves-tag-icon">
              <img
                src={
                  icon
                    ? (() => {
                      try {
                        return require("../../images/" + icon);
                      } catch (e) {
                        return PlaceHolderIcon;
                      }
                    })()
                    : PlaceHolderIcon
                }
                style={{ width: 16, height: 16 }}
              />
            </div>
            <span>{itemText}</span>
          </div>
        );
      })
    );
  };

  const isNiceToHaveExist = nice2Have.length > 0;

  const loadDetails = () => {
    return buildInventoryMustHaveHtml({
      typeBasedOnProperty: typeBasedOnProperty,
      formValues: inventoryDetails,
    });
  };

  let successPopUpTitle;
  let successPopUpDesc;
  if (showStrengthenSuccess) {
    successPopUpTitle = "Your inventory looks great!";
    successPopUpDesc =
      "We've successfully added additional details about your inventory.";
  } else {
    successPopUpTitle = "You've successfully added your inventory.";
    successPopUpDesc =
      "Start browsing the ad-feed to find people who are looking for what you have. You can use the 'Match' option on the filter panel to find want-listings that match your property.";
  }
  const photos = _.get(inventoryDetails, "photos", []);
  const highSchool = _.get(inventoryDetails, "highSchool", null);
  const neighborHood = _.get(inventoryDetails, "neighborHood", null);
  const location = _.get(inventoryDetails, "locAddress", null);

  const _photos =
    photos.length > 0
      ? photos
      : mapImg
        ? [{ image: mapImg, IsValid: true }]
        : [];

  const getPendingIntroductionList = async () => {
    const userId = getUserId();

    const page = 1;
    const reqPayload = {
      inventoryId: inventoryId,
      page: page,
      limit: PAGE_LIMIT,
    };
    await getMyPendingIntroductionByInvId(reqPayload).then((response) => {
      if (response) {
        const result = _.get(response, "result", null);
        if (response.errorCode === 0) {
          setPendingIntroductionsCount(result?.Count);
          setPendingIntroductions(result?.List);
        } else {
          console.log(`####error`);
        }
      }
    });
  };
  /**
   * To get accepted introductions list
   */
  const getAcceptdIntroductions = async () => {
    const userId = getUserId();

    const page = 1;
    const reqPayload = {
      inventoryId: inventoryId,
      page: page,
      limit: PAGE_LIMIT,
    };
    await getMyAcceptedIntroductionByInvId(reqPayload).then((response) => {
      if (response) {
        const result = _.get(response, "result", null);
        if (response.errorCode === 0) {
          setAcceptedIntroductionsCount(result?.Count);
        } else {
          console.log(`####error`);
        }
      }
    });
  };

  const onMarkAsSold = () => {
    handleMarkAsSoldModal(true);
  };
  /**
   * To handle inventory mark as sold
   * @param {*} inventoryId
   * @param {*} didGitchHelped
   * @param {*} salesPrice
   */
  const handleInventoryMarkAsSold = async (
    inventoryId,
    didGitchHelped,
    salesPrice,
  ) => {
    const newPrice = salesPrice?.replace("$", "");
    if (inventoryId) {
      const payload = {
        inventoryId: inventoryId,
        didGitchHelped: didGitchHelped === true ? 1 : 0,
        salesPrice: newPrice ? replaceComma(newPrice) : null,
      };
      await inventoryMarkAsSold(payload)
        .then((response) => {
          const responseResult = _.get(response, "result", null);
          if (response.errorCode === 0 && responseResult) {
            toast.success("Your inventory has been successfully mark as sold.");
            GitchaHelpFeedbackModalClose();
            setMarkAsSoldStatus(!markAsSoldStatus);
            navigate(pageURLs.consumerInventoryListing);
          } else {
            console.log("Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    }
  };

  const onInventoryDelete = () => {
    setDeleteModalShow(true);
  };

  /**
   * To handle the inventory delete
   */
  const handleDeleteInventory = async () => {
    if (inventoryId) {
      await deleteMyInventory(inventoryId)
        .then((response) => {
          const responseResult = _.get(response, "result", null);

          if (response.errorCode === 0 && responseResult) {
            toast.success("Your property has been deleted.");
            setDeleteModalShow(false);
            setDeleteStatus(!deleteStatus);
            navigate(pageURLs.consumerInventoryListing);
          } else {
            console.log("Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    }
  };
  /**
   * To handle edit want ad
   */
  const onEdit = () => {
    if (inventoryDetails?.isAgentCreated === 1) {
      navigate(pageURLs.agentCreateInventory, {
        state: {
          data: inventoryDetails,
          inventoryId: inventoryId,
        },
      });
    } else {
      navigate(pageURLs.memberEditInventory, {
        state: { data: inventoryDetails },
      });
    }
  };

  const handleSortParam = (selectedOption) => {
    setMatchQuery((prev) => ({
      ...prev,
      sortType: selectedOption.value,
    }));
  };

  const handleWantAdItemClick = (wantAdId, slug) => {
    navigate(`${pageURLs.wantAdDetails}/${slug}`);
  };

  const handleFavoriteOrUnfavoriteWantAd = async (
    IsFavourite,
    Want_ad_Id,
    clientId = [],
  ) => {
    if (Want_ad_Id) {
      setReload(false);
      let data = {
        clientId: IsFavourite == false ? clientId : null,
        wantAdId: Want_ad_Id,
      };
      await (
        IsFavourite == false ? favouriteWantAd(data) : unFavouriteWantAd(data)
      )
        .then((response) => {
          if (response.errorCode == 0) {
            let message = "";
            if (clientId.length > 0) {
              message =
                "Want-Listing has been favorited for " +
                clientId.length +
                (clientId.length > 1 ? " clients" : " client");
            } else {
              message =
                IsFavourite == true
                  ? "Want-Listing has been removed from your favorites"
                  : "Want-Listing has been added to your favorites";
            }

            toast.success(message);
            setCurrPage(1);
            setAdList([]);
            setAdListgitchaGenie([]);
            if (isGitchaGenieFilter) {
              setReload(true);
            } else {
              updateQuery(initialQuery);
            }
          } else {
            console.log("Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    }
  };

  const MatchesTab = () => {
    const hasNoData = matches?.length <= 0;
    const shouldShowPlaceholder = hasNoData && !isMatchesLoading;

    if (isMatchesLoading) {
      return <MatchesSkeleton />;
    }

    if (shouldShowPlaceholder) {
      return <div></div>;
    }

    const handleShowMoreClick = () =>
      setMatchQuery((prev) => ({ ...prev, page: prev.page + 1 }));

    return (
      <>
        <div className="sort-items-panel">
          <div className="sort-items-inner-wrapper">
            <div className="row">
              <h1 className="member-inventory-details-title">
                Potential Buyers for {formatInventoryAddress(location)}
              </h1>
              <div className="d-flex mb-4">
                <div className="col">
                  <h2 className="member-inventory-details-subtitle" data-tour="inventory-matches-header">
                    {totalMatches} Matches to Want-Listings
                  </h2>
                  {/* Download Report - BLS only (agents use reports for listing appointments) */}
                  {!isGitchaDefaultWebsite && (
                    <Button
                      className="btn-grey"
                      onClick={() => {
                        const id = inventory?.inventoryId;
                        if (id) navigate(`/reports/active-buyer/${id}?edit=1`);
                      }}
                      data-tour="download-report"
                      style={{
                        marginBottom: 24,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 180,
                        padding: 0,
                        height: 40,
                        letterSpacing: "unset",
                      }}
                    >
                      Download Report
                      <img
                        src={downloadIconTwo}
                        style={{ width: 12, height: 12, marginLeft: 8 }}
                      />
                    </Button>
                  )}
                  {/* View Demand Analytics - navigate to feed Match tab with this property */}
                  <Button
                    className="btn-primary"
                    onClick={() => {
                      setLocalStorage("FilterTabKey", "match");
                      setLocalStorage("selectedPropertyId", { Inv_Id: inventoryId });
                      navigate("/home");
                    }}
                    style={{
                      marginBottom: 24,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 220,
                      padding: 0,
                      height: 40,
                      letterSpacing: "unset",
                    }}
                  >
                    View Demand Analytics
                  </Button>
                </div>
                <div style={{ width: "auto !important" }}>
                  <div className="d-flex select-wrap position-relative gap-3">
                    <Form.Label style={{ fontSize: 15 }}>Sort By:</Form.Label>
                    <SelectDropDown
                      id="multi3"
                      name="colors3"
                      options={options}
                      className="basic-single sort-select d-inline-block mb-0"
                      classNamePrefix="select"
                      placeholder="Select"
                      value={options.find(
                        (opt) => opt.value === matchQuery.sortType,
                      )}
                      onChange={handleSortParam}
                      styles={{
                        dropdownIndicator: (provided, state) => ({
                          ...provided,
                          transform:
                            state.selectProps.menuIsOpen && "rotate(180deg)",
                        }),
                      }}
                      errorClass="d-none"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div data-tour="inventory-match-cards">
          {matches?.map((wa, index) => (
            <PropertyWantAdListing
              list={wa}
              key={index}
              handleFavoriteOrUnfavoriteWantAd={handleFavoriteOrUnfavoriteWantAd}
              handleWantAdItemClick={handleWantAdItemClick}
            />
          ))}
        </div>

        {hasNextPage ? (
          <div className="text-center pt-3 pb-3 w-100">
            <button
              className="btn btn-primary"
              onClick={() => handleShowMoreClick()}
              disabled={isMatchesLoading}
            >
              {isMatchesLoading ? "Loading..." : "Show More"}
            </button>
          </div>
        ) : null}
      </>
    );
  };

  return (
    <PageTransition>

      <PageWrapper
        ref={pageTopRef}
        headerSidebarProps={{ updateInventoryState: getInventoryDetails }}
      >
        <div className="tab-wrap pb-5">
          <Tabs
            className="mb-3"
            activeKey={tabKey}
            onSelect={(k) => {
              if (k === "Matches") {
                // Navigate to Feed Match tab with this property pre-selected
                setLocalStorage("FilterTabKey", "match");
                setLocalStorage("selectedPropertyId", { Inv_Id: inventoryId });
                sessionStorage.removeItem("feed_scrollTop");
                navigate("/home");
                return;
              }
              setTabKey(k);
            }}
          >
            <Tab eventKey={"Property Details"} title={"Property Details"}>
              <div className="row">
                <div className="col-12 col-md-7 ps-md-3 col-lg-8 ps-lg-3 col-xl-8 ps-xl-2">
                  <div className="inventory-confirmation-wrap">
                    <div className="confirmation-top-sec d-md-flex justify-content-between">
                      <div>
                        {_.get(inventoryDetails, "isSold", "") ? (
                          <span
                            className={
                              isSold
                                ? "want-ad-tag align-middle orange-tag-bg mb-0 f-size-10"
                                : "want-ad-tag align-middle green-tag-bg mb-0 f-size-10"
                            }
                          >
                            {titleText}
                          </span>
                        ) : (
                          <></>
                          // <div className="confirm-sub-title mb-1">
                          //   I'm open to:{" "}
                          //   <span className="want-ad-tag align-middle green-tag-bg mb-0 f-size-10">
                          //     {titleText}
                          //   </span>
                          // </div>
                        )}

                        <h2 className="long-txt-fix">
                          {formatInventoryAddress(
                            _.get(inventoryDetails, "locAddress", ""),
                          )}
                        </h2>
                      </div>
                      <div className="social-btns-wrap">
                        <Dropdown>
                          <Dropdown.Toggle variant="" id="dropdown-basic1">
                            <img src={MoreIcon} />
                          </Dropdown.Toggle>
                          <Dropdown.Menu align="end">
                            {!isSold && (
                              <Dropdown.Item onClick={() => onMarkAsSold()}>
                                Mark as sold
                              </Dropdown.Item>
                            )}
                            {!isSold && (
                              <Dropdown.Item onClick={() => onEdit()}>
                                Edit
                              </Dropdown.Item>
                            )}
                            {inventoryId && (
                              <Dropdown.Item
                                onClick={() => navigate(`/reports/active-buyer/${inventoryId}`)}
                              >
                                Generate Active Buyer Report
                              </Dropdown.Item>
                            )}
                            <Dropdown.Item onClick={() => onInventoryDelete()}>
                              Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>

                   {isMember && <PhotoGallery photos={_photos} isFromDetailsPage={true} />}

                    <div className="musthave-wrap">
                      <h2>Details</h2>
                      {loadDetails()}
                    </div>

                    <div className="Inventory-Location-wrap pb-32 border-bottom-0">
                      <h2>Location</h2>
                      <div className="Inventory-Location-map-wrap mb-3 h-264">
                        <MapBoxComponent center={[lng, lat]} />
                      </div>
                      <ul>
                        {highSchool && (
                          <li>
                            <span className="Inventory-icn-wrap">
                              <img src={SchoolSmallIcon} />
                            </span>
                            {highSchool}
                          </li>
                        )}
                        {neighborHood && (
                          <li>
                            <span className="Inventory-icn-wrap">
                              <img src={NeighborhoodIcon} />
                            </span>
                            {neighborHood}
                          </li>
                        )}
                      </ul>
                    </div>

                    {isNiceToHaveExist ? (
                      <div className="nicetohaves-wrap border-bottom-0">
                        <h2>Features</h2>
                        <div className="nicetohaves-inner-wrap">
                          {finalNiceToHaveList()}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                  </div>
                </div>

                {isFromListingPage &&
                  (pendingIntroductionsCount > 0 ||
                    acceptedIntroductionsCount > 0) ? (
                  <div className="col-12 col-md-5 pe-md-3 col-lg-4 pe-lg-3 col-xl-4 pe-xl-2">
                    <div className="ad-strengthen-wrap mb-0 mb-sm-4">
                      <h6 className="strengthen-sub-head">
                        My pending introductions
                      </h6>

                      <div className="view-intro-wrap">
                        {pendingIntroductions &&
                          pendingIntroductions.map((introduction) => {
                            return (
                              <div className="add-your-property-wrap flex-column mb-4">
                                <div className="d-flex w-100 mb-2">
                                  <div className="pending-intro-img">
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M12 2.50781C11.4257 2.50781 10.8515 2.69464 10.377 3.06836H10.376L4.42969 7.75488C3.52791 8.46557 3 9.55149 3 10.7002V19.7441C3 20.7016 3.79252 21.4941 4.75 21.4941H19.25C20.2075 21.4941 21 20.7016 21 19.7441V10.7002C21 9.55149 20.4721 8.46557 19.5703 7.75488L19.5 7.69824V3.75C19.5 3.55109 19.421 3.36034 19.2803 3.21969C19.1397 3.07904 18.9489 3.00002 18.75 3H16.25C16.0511 3.00002 15.8603 3.07904 15.7197 3.21969C15.579 3.36034 15.5 3.55109 15.5 3.75V4.54688L13.623 3.06836C13.1485 2.69464 12.5743 2.50781 12 2.50781ZM12 4.00391C12.2449 4.00391 12.4899 4.08529 12.6953 4.24707L15.7861 6.68164C15.8967 6.76865 16.0296 6.82279 16.1695 6.83789C16.3094 6.85298 16.4507 6.82842 16.5773 6.767C16.7039 6.70558 16.8107 6.60979 16.8854 6.49056C16.9602 6.37134 16.9999 6.23349 17 6.09277V4.5H18V8.0625C18.0001 8.1759 18.0259 8.2878 18.0754 8.3898C18.125 8.4918 18.197 8.58123 18.2861 8.65137L18.6426 8.93262C19.1848 9.35993 19.5 10.0099 19.5 10.7002V19.7441C19.5 19.8917 19.3975 19.9941 19.25 19.9941H4.75C4.60248 19.9941 4.5 19.8917 4.5 19.7441V10.7002C4.5 10.0099 4.8152 9.35993 5.35742 8.93262L11.3047 4.24707C11.5101 4.08529 11.7551 4.00391 12 4.00391ZM7.25 11.9941C7.05109 11.9942 6.86034 12.0732 6.71969 12.2138C6.57904 12.3545 6.50002 12.5452 6.5 12.7441V16.7441C6.50002 16.943 6.57904 17.1338 6.71969 17.2744C6.86034 17.4151 7.05109 17.4941 7.25 17.4941H10.25C10.4489 17.4941 10.6397 17.4151 10.7803 17.2744C10.921 17.1338 11 16.943 11 16.7441V12.7441C11 12.5452 10.921 12.3545 10.7803 12.2138C10.6397 12.0732 10.4489 11.9942 10.25 11.9941H7.25ZM13.75 11.9941C13.5511 11.9942 13.3603 12.0732 13.2197 12.2138C13.079 12.3545 13 12.5452 13 12.7441V16.7441C13 16.943 13.079 17.1338 13.2197 17.2744C13.3603 17.4151 13.5511 17.4941 13.75 17.4941H16.75C16.9489 17.4941 17.1397 17.4151 17.2803 17.2744C17.421 17.1338 17.5 16.943 17.5 16.7441V12.7441C17.5 12.5452 17.421 12.3545 17.2803 12.2138C17.1397 12.0732 16.9489 11.9942 16.75 11.9941H13.75ZM8 13.4941H9.5V15.9941H8V13.4941ZM14.5 13.4941H16V15.9941H14.5V13.4941Z"
                                        fill="#007EF5"
                                      />
                                    </svg>
                                  </div>

                                  <div className="make-intro-details d-flex flex-column justify-content-center pe-0">
                                    <h3 className="mb-0">
                                      {truncate(introduction?.Title_Text, 25)}
                                    </h3>

                                    <ul className="intro-list">
                                      <li>
                                        {" "}
                                        {introduction?.Bedrooms == 99
                                          ? "Any"
                                          : introduction?.Bedrooms + "+"}{" "}
                                        Beds
                                      </li>
                                      <li>
                                        <span>&bull;</span>{" "}
                                        {introduction?.Bathrooms == 99
                                          ? "Any"
                                          : introduction?.Bathrooms + "+"}{" "}
                                        Baths
                                      </li>
                                      <li>
                                        <span>&bull;</span>{" "}
                                        {wantAdSqftValue(
                                          introduction?.Sqft_mn,
                                          introduction?.Sqft_mx,
                                        )}{" "}
                                        sqft
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <div className="pending-intro-btm">
                                  <span className="pending-intro-date">
                                    <img
                                      src={IntroSentIcon}
                                      className="align-text-top"
                                    />
                                    {moment(
                                      new Date(introduction.CreatedOn),
                                    ).format("MMMM Do, YYYY")}
                                  </span>
                                  <span className="pending-intro-tag">
                                    <img
                                      src={IntroTagIcon}
                                      className="align-text-top"
                                    />
                                    $
                                    {thousandSeperatedValue(
                                      introduction?.AskingPrice,
                                    )}
                                  </span>
                                </div>
                              </div>
                            );
                          })}

                        {acceptedIntroductionsCount > 0 &&
                          pendingIntroductionsCount == 0 && (
                            <p>No Pending Introductions. </p>
                          )}
                      </div>

                      <Button
                        variant="primary"
                        className="w-100 mb-0 mt-3 l-spacing-0"
                        onClick={() => {
                          navigate("/view-all-introductions", {
                            state: {
                              inventoryId: inventoryId,
                              title: _.get(inventoryDetails, "locAddress", ""),
                            },
                          });
                        }}
                      >
                        View All
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div className="col-12 col-md-5 pe-md-3 col-lg-4 pe-lg-3 col-xl-4 pe-xl-2" data-tour="send-intro-panel">
                    {showStrengthen && !agent && !_.get(inventoryDetails, "Represent_as_Seller", 0) && (
                      <div className="ad-strengthen-wrap mb-4">
                        <div className="icon-wrap">
                          <img src={StrengthenIcon} alt={StrengthenIcon} />
                        </div>
                        <h4>Want to get more successful introductions?</h4>
                        <p className="mb-4">
                          Adding additional information about your property
                          gives people a better idea of what you have.
                        </p>
                        <Button
                          variant="primary"
                          className="w-100 mb-4 l-spacing-0"
                          onClick={() => navigate(pageURLs.inventoryStrengthen)}
                        >
                          Strengthen my Property
                        </Button>
                        <a
                          href={void 0}
                          role="button"
                          className="dismiss-btn d-block"
                          onClick={() => handleStrengthenDismiss()}
                        >
                          Dismiss
                        </a>
                      </div>
                    )}
                    {inventoryDetails &&
                      !_.get(inventoryDetails, "isSold", "") &&
                      _.get(inventoryDetails, "isSold", "") !== 1 &&
                      !_.get(inventoryDetails, "Represent_as_Seller", 0) && (
                        <div className="ad-strengthen-wrap mb-0 mb-sm-4">
                          <div className="icon-wrap">
                            <img src={AdIntroIcon} alt={AdIntroIcon} />
                          </div>
                          <h6>
                            {isFromListingPage
                              ? "When you send an introduction to a want-listing, it will appear here."
                              : "When you send an introduction to a want-listing, you'll see it here."}
                          </h6>
                          <p className="mb-4">
                            {isFromListingPage
                              ? "Use the match filter in the Listing feed to see the want-listings that match your property."
                              : "You can start a message thread by either sending or responding to an introduction on a want listing"}
                          </p>
                          <Button
                            variant=""
                            className={
                              isFromListingPage
                                ? "btn btn-primary l-spacing-0 w-100 mb-0"
                                : "btn btn-secondary l-spacing-0 w-100 mb-0"
                            }
                            onClick={() => navigate("/home")}
                          >
                            View want listings
                          </Button>
                        </div>
                      )}
                  </div>
                )}
              </div>
            </Tab>
            <Tab eventKey={"Matches"} title={`Matches (${totalMatches})`} data-tour="inventory-matches-tab">
              <MatchesTab />
            </Tab>
          </Tabs>
        </div>
      </PageWrapper>

      <InventorySuccessModal
        show={showSuccessModal}
        onHide={handleSuccessModalClose}
        showStrengthenSuccessModal={showStrengthenSuccess}
        successPopUpTitle={successPopUpTitle}
        successPopUpDesc={successPopUpDesc}
      />
      <MarkAsSoldConfirmModal
        show={markAsSoldModalShow}
        onHide={handleMarkAsSoldModal}
        handleInventoryMarkAsSold={() => {
          GitchaHelpFeedbackModalShow();
          handleMarkAsSoldModal(false);
        }}
        inventoryId={inventoryId}
      />
      <HelpFeedbackModal
        show={showGitchaHelpFeedbackModal}
        onHide={GitchaHelpFeedbackModalClose}
        handleInventoryMarkAsSold={handleInventoryMarkAsSold}
        inventoryId={inventoryId}
      />
      <DeleteModal
        show={deleteModalShow}
        onHide={() => setDeleteModalShow(false)}
        title={"Are you sure you want to permanently delete your property?"}
        message={
          "Deleting this property from your inventory will remove any pending and accepted introductions sent by you."
        }
        buttonText={" Delete Property"}
        handleConfirm={() => handleDeleteInventory()}
      />
    </PageTransition>
  );
};

export default InventoryDetails;
